import React from 'react';
import { LazyImage } from 'project/lazy-image';
import { SpriteSvg } from 'project/sprite-svg';
import { liveHole } from 'components/live-hole';

const CourseTile = ({ hole }) => {
    if (!hole || !hole.sitecoreData) return null;

    const sitecoreData = hole.sitecoreData;

    return (
        <div className="course-tile">
            <div
                className="course-tile__container"
                onClick={() => liveHole.show(hole.id)}
            >
                <div className="course-tile__background">
                    <LazyImage image={sitecoreData.holeSrc} />
                </div>
                <div className="course-tile__content">
                    <div className="course-tile__info-container">
                        {/*{ TODO: change to hole-flag }*/}
                        <div className="course-tile__number-wrapper">
                            <div className="course-tile__number">{sitecoreData.holeNumber}</div>
                        </div>
                        <div className="course-tile__text-info">
                            <div className="course-tile__par">par {hole.par}</div>
                            <div className="course-tile__yardage">{sitecoreData.holeYardage} yds</div>
                        </div>
                    </div>
                    <SpriteSvg iconName="arrow-right" width="16" height="14" />
                </div>
            </div>
        </div>
    );
};

export default CourseTile;
